import React from "react";
import Context from "../../../Context";

import ObjectInspector from "react-object-inspector";
import Blocker from "../../Misc/Blocker";
export default class TaskDetail extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });
    let item = await this.context.api.q("/task/get", { id: this.props.id });
    this.setState({ pending: false, item });
  };

  render() {
    return (
      <>
        <Blocker on={this.state.pending}>
          <ObjectInspector
            data={this.state.item}
            initialExpandedPaths={["root"]}
          />
        </Blocker>
      </>
    );
  }
}
